import { resolveAuthenticatedHeaders } from '@/utils/requestContext.js';

const API_BASE = String(import.meta.env.VITE_API_URL || '').replace(/\/$/, '');
const ENDPOINT = `${API_BASE}/api/facturas/email-settings`;

async function request(method, body, suffix = '') {
  const response = await fetch(`${ENDPOINT}${suffix}`, {
    method,
    headers: resolveAuthenticatedHeaders(body ? { 'Content-Type': 'application/json' } : {}),
    credentials: 'include',
    body: body ? JSON.stringify(body) : undefined,
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok || !payload?.ok) throw new Error(payload?.message || 'No se pudo procesar la configuración de correo.');
  return payload.data;
}

export const getInvoiceEmailSettings = () => request('GET');
export const saveInvoiceEmailSettings = (settings) => request('PUT', settings);
export const testInvoiceEmailConnection = () => request('POST', undefined, '/test-connection');
export const sendInvoiceEmailTest = (recipient) => request('POST', { recipient }, '/send-test');
